module.exports = __webpack_public_path__ + "static/media/40X35 ratlam_page-0001.da0117bc.jpg";